import { Box, BoxProps } from "@chakra-ui/react";
import { useEffect, useMemo, useRef, useState } from "react";
import { get12HrTime, getStartOfDay } from "../utils/time";
import { MILLISECONDS_IN_HOUR } from "common";

interface CurrentCalendarTimeProps extends BoxProps {
  hourHeight: string;
  timeWidth: string;
  calendarPaddingTop: string;
  startOfCalendarDayMs: number;
}

export const CurrentCalendarTime = ({
  hourHeight,
  timeWidth,
  calendarPaddingTop,
  startOfCalendarDayMs,
  ...props
}: CurrentCalendarTimeProps) => {
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [now, setNow] = useState(Date.now());
  const startOfToday = useMemo(() => getStartOfDay(now), [now]);

  const msSinceStartOfToday = useMemo(
    () => Math.max(0, now - startOfToday),
    [now, startOfToday]
  );

  useEffect(() => {
    const id = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(id);
    };
  }, []);

  useEffect(() => {
    if (startOfToday === startOfCalendarDayMs) {
      elementRef.current?.scrollIntoView();
    }
  }, [startOfCalendarDayMs, startOfToday]);

  // Not on the same day so don't show
  if (startOfCalendarDayMs !== startOfToday) {
    return null;
  }

  return (
    <Box
      right={0}
      position={"absolute"}
      top={`calc(${hourHeight} * ${
        msSinceStartOfToday / MILLISECONDS_IN_HOUR
      } + ${calendarPaddingTop})`}
      transform={"translateY(-50%)"}
      width={"100%"}
      display={"flex"}
      alignItems={"center"}
      zIndex={10}
      {...props}
    >
      <Box
        ref={elementRef}
        position={"absolute"}
        top={"50%"}
        right={"100%"}
        width={"1px"}
        transform={"translate(0, -50%)"}
        height={"200px"}
      />
      <Box
        minWidth={timeWidth}
        fontWeight={"400"}
        fontSize={"12px"}
        color={"red.500"}
      >
        {get12HrTime(now)}
      </Box>
      <Box
        height={"1px"}
        width={"100%"}
        backgroundColor={"red.500"}
        position={"relative"}
      >
        <Box
          width={"7px"}
          height={"7px"}
          borderRadius={"50%"}
          backgroundColor={"red.500"}
          position={"absolute"}
          left={0}
          top={"50%"}
          transform={"translate(-50%,-50%)"}
        />
      </Box>
    </Box>
  );
};
